import { Link } from "react-router-dom";
import Navigation from "../components/layout/Navigation";
import Footer from "../components/layout/Footer";
import { Button } from "../components/ui/button";
import { motion } from "framer-motion";
import { Home, Search, ArrowLeft } from "lucide-react";

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-background" data-testid="not-found-page">
      <Navigation />

      <section className="pt-32 pb-24 px-6 md:px-12 flex items-center justify-center min-h-[70vh]">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center max-w-lg"
        >
          <div className="text-8xl font-bold text-primary/20 mb-4 font-serif">404</div>
          <h1 className="text-3xl md:text-4xl font-medium mb-4">
            This Path Leads Elsewhere
          </h1>
          <p className="text-muted-foreground mb-10 leading-relaxed">
            Like a songline that has shifted, the page you're looking for has moved or
            no longer exists. Let us guide you back to the collection.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/">
              <Button className="rounded-full px-8 gap-2" data-testid="404-home-btn">
                <Home className="h-4 w-4" />
                Return Home
              </Button>
            </Link>
            <Link to="/products">
              <Button variant="outline" className="rounded-full px-8 gap-2" data-testid="404-browse-btn">
                <Search className="h-4 w-4" />
                Browse Collection
              </Button>
            </Link>
          </div>
          <button
            onClick={() => window.history.back()}
            className="mt-6 text-sm text-muted-foreground hover:text-foreground transition-colors inline-flex items-center gap-1"
          >
            <ArrowLeft className="h-3 w-3" />
            Go back
          </button>
        </motion.div>
      </section>

      <Footer />
    </div>
  );
};

export default NotFoundPage;
